import React, { useState, useEffect, useCallback } from "react";
import {
  Grid,
  Paper,
  Table,
  TableRow,
  TableCell,
  TableContainer,
  TableHead,
  TableBody,
  TextField,
  Box,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import * as actions from "./actions";
import { API_URL } from "../../constants";
import _ from "lodash";

import { toastError } from "../../utils";
import CustomShowModal from "../Common/customShowModal";

export default function Promotions(props) {
  const [count, setCount] = useState(0);
  const [promo, setPromo] = useState();
  const [filters, setFilters] = useState({
    limit: 30,
    offset: 0,
    page: 1,
    search: "",
  });

  const [previewImage, setPreviewImage] = useState("");
  const [openPreview, setOpenPreview] = useState(false);

  const delaySearch = useCallback(
    _.debounce((filters) => getPromotions(filters), 500),
    []
  );

  useEffect(() => {
    getPromotions(filters);
    setTimeout(() => {
      props.setLoader(false);
    }, 5000);
  }, []);

  const getPromotions = (filters) => {
    props.setLoader(true);
    actions
      .getPromotionsAdmin({ ...filters })
      .then((res) => {
        props.setLoader(false);
        setPromo(res.body);
        setCount(res.total);
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err?.message || 'Operation failed');
      });
  };

  const onPageChange = (event, page) => {
    const offset = (page - 1) * filters.limit;
    const newFilters = { ...filters, page, offset };
    setFilters(newFilters);
    getPromotions(newFilters);
  };

  const onChangeSearch = (e) => {
    const newFilters = { ...filters, search: e.target.value };
    setFilters(newFilters);
    delaySearch(newFilters);
  };

  const handleImageClick = (imgPath) => {
    setPreviewImage(`${API_URL}/${imgPath}`);
    setOpenPreview(true);
  };

  const handleClosePreview = () => {
    setOpenPreview(false);
    setPreviewImage("");
  };

  let totalPages = Math.ceil(Number(count) / filters.limit);

  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <p style={{ fontWeight: 500 }}>Review Required</p>

          <Box mt={2}>
            <TextField
              type="text"
              variant="outlined"
              size="small"
              onChange={onChangeSearch}
              value={filters.search}
              placeholder="Search..."
              sx={{
                fontFamily: "'DM Sans', sans-serif",
                color: "#fff",
                width: "100%",
                "& label": {
                  fontFamily: "'DM Sans', sans-serif",
                  color: "white",
                },
                "& label.Mui-focused": {
                  color: "white",
                },
                "& .MuiInput-underline:after": {
                  borderBottomColor: "red",
                },
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: "#10baa8",
                    borderWidth: "1px",
                  },
                },
              }}
            />
          </Box>
        </Grid>

        <Grid item xs={12} style={{ marginTop: "20px" }}>
          <h2
            style={{
              fontWeight: 500,
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            Promotions History
          </h2>
          <TableContainer component={Paper}>
            <Table className="universal-table">
              <TableHead>
                <TableRow
                  style={{
                    background:
                      "linear-gradient(90deg, rgba(19,153,121,1) 0%, rgba(18,180,161,1) 45%, rgba(5,150,179,1) 100%)",
                  }}
                >
                  <TableCell className="color-white">PromotionId</TableCell>
                  <TableCell className="color-white">Name</TableCell>
                  <TableCell className="color-white">Email</TableCell>
                  <TableCell className="color-white">Song Name</TableCell>
                  <TableCell className="color-white">Platform</TableCell>
                  <TableCell className="color-white">Promo Type</TableCell>
                  <TableCell className="color-white">Playlist Name</TableCell>
                  <TableCell className="color-white">Link</TableCell>
                  <TableCell className="color-white">Image</TableCell>
                  <TableCell className="color-white">Created On</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {promo?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.promotion_id}</TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{item.email}</TableCell>
                    <TableCell>{item.song}</TableCell>
                    <TableCell>{item.platform}</TableCell>
                    <TableCell>{item.type}</TableCell>
                    <TableCell>{item.playlist_name}</TableCell>
                    <TableCell>
                      <a href={item.playlist_link} target="_blank" rel="noopener noreferrer">
                        Click here
                      </a>
                    </TableCell>
                    <TableCell align="left" style={{ padding: 4 }}>
                      <div
                        className="album-artwork-catalog"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleImageClick(item.image)}
                      >
                        <img
                          src={`${API_URL}/${item.image}`}
                          height="60px"
                          alt=""
                        />
                      </div>
                    </TableCell>
                    <TableCell>{item.created_at}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Pagination
              count={totalPages}
              showFirstButton
              showLastButton
              onChange={onPageChange}
              page={filters.page || 0}
            />
          </TableContainer>
        </Grid>
      </Grid>

      <CustomShowModal
        handleClose={handleClosePreview}
        title={"Preview Image"}
        open={openPreview}
        maxWidth="sm"
      >
        <div style={{ textAlign: "center" }}>
          <img
            src={previewImage}
            alt="Preview"
            style={{ maxWidth: "100%", maxHeight: "400px", borderRadius: 8 }}
          />
        </div>
      </CustomShowModal>
    </div>
  );
}